import { CategoryType } from '../components/CategoryLabel/models';

export enum DiscountType {
  None,
  Percentage,
  Amount,
}

export interface ProductApiModel {
  sku: string;
  name: string;
  shortDescription: string;
  quantityTotal: number;
  quantityRemaining: number;
  quantityRedeemed: number;
  discountType: DiscountType;
  discount: number;
  priceBase: number;
  price: number;
  priceTotal: number;
  priceRedeemed: number;
  type: CategoryType;
  fullDescription?: string;
  totalPDUs?: number;
  businessAcumenPDUs?: number;
  powerSkillsPDUs?: number;
  waysOfWorkingPDUs?: number;
  length?: number;
  level?: number;
  totalSpend?: number;
  totalSavings?: number;
  bundle: boolean;
  retired?: boolean;
  quantityAssigned?: number;
  quantityNotAssigned?: number;
  quantityNotRedeemed?: number;
  quantityRefunded?: number;
  accountProductId?: number;
}
